import {
  FETCH_PURCHASE_ORDERS,
  FETCH_PURCHASE_ORDER_DETAIL,
  CREATE_PURCHASE_ORDER,
  DELETE_PURCHASE_ORDER,
  CREATE_PURCHASE_ORDER_ITEM_LABEL,
  DELETE_PURCHASE_ORDER_ITEM_LABEL,
  CREATE_MULTIPLE_PURCHASE_ORDER,
  FETCH_MULTIPLE_PURCHASE_ORDER,
  CLEAR_PURCHASE_ORDER_DETAIL,
} from "./types";
import * as API from "./api";

// --------------------------------------------------------------------------
// FETCH_PURCHASE_ORDERS
// --------------------------------------------------------------------------
export const fetchPurchaseOrders = (page, purchaseOrderId, vendor, status, date) => ({
  type: FETCH_PURCHASE_ORDERS.init,
  payload: API.fetchPurchaseOrders(page, purchaseOrderId, vendor, status, date),
});

export const fetchPurchaseOrdersSuccess = (info) => ({
  type: FETCH_PURCHASE_ORDERS.success,
  payload: info,
});

export const fetchPurchaseOrdersFailure = (error) => ({
  type: FETCH_PURCHASE_ORDERS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_PURCHASE_ORDER_DETAIL
// --------------------------------------------------------------------------
export const fetchPurchaseOrderDetail = (id) => ({
  type: FETCH_PURCHASE_ORDER_DETAIL.init,
  payload: API.fetchPurchaseOrderDetail(id),
});

export const fetchPurchaseOrderDetailSuccess = (info, list = false) => {
  if (list) {
    return {
      type: FETCH_MULTIPLE_PURCHASE_ORDER.success,
      payload: info,
    };
  } else {
    return {
      type: FETCH_PURCHASE_ORDER_DETAIL.success,
      payload: info,
    };
  }
};

export const fetchPurchaseOrderDetailFailure = (error) => ({
  type: FETCH_PURCHASE_ORDER_DETAIL.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// CREATE_PURCHASE_ORDER_ITEM_LABEL
// --------------------------------------------------------------------------
export const createPurchaseOrderItemLabelSuccess = (info) => ({
  type: CREATE_PURCHASE_ORDER_ITEM_LABEL.success,
  payload: info,
});

// --------------------------------------------------------------------------
// DELETE_PURCHASE_ORDER_ITEM_LABEL
// --------------------------------------------------------------------------

export const deletePurchaseOrderItemLabelSuccess = (info) => ({
  type: DELETE_PURCHASE_ORDER_ITEM_LABEL.success,
  payload: info,
});

// --------------------------------------------------------------------------
// CREATE_PURCHASE_ORDER
// --------------------------------------------------------------------------
export const createPurchaseOrder = (data) => ({
  type: CREATE_PURCHASE_ORDER.init,
  payload: API.createPurchaseOrder(data),
});

export const createPurchaseOrderSuccess = (info, list = false) => {
  if (list) {
    return {
      type: CREATE_MULTIPLE_PURCHASE_ORDER.success,
      payload: info,
    };
  } else {
    return {
      type: CREATE_PURCHASE_ORDER.success,
      payload: info,
    };
  }
};

export const createPurchaseOrderFailure = (error) => ({
  type: CREATE_PURCHASE_ORDER.failure,
  payload: error,
});

// ---------------------------------------------------------------------------
// CLEAR_PURCHASE_ORDER_DETAIL
// ---------------------------------------------------------------------------
export const clearPurchaseOrderDetail = () => {
  return {
    type: CLEAR_PURCHASE_ORDER_DETAIL,
  };
};
// --------------------------------------------------------------------------
// DELETE_PURCHASE_ORDER
// --------------------------------------------------------------------------
export const deletePurchaseOrder = (id) => ({
  type: DELETE_PURCHASE_ORDER.init,
  payload: API.deletePurchaseOrder(id),
});

export const deletePurchaseOrderSuccess = (id) => {
  return {
    type: DELETE_PURCHASE_ORDER.success,
    payload: id,
  };
};

export const deletePurchaseOrderFailure = (error) => ({
  type: DELETE_PURCHASE_ORDER.failure,
  payload: error,
});
